import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	name: {
		id: 'inactive-projects-directory-base.projects-table.header.name',
		defaultMessage: 'Name',
		description: 'Projects table column heading for name values',
	},
	key: {
		id: 'inactive-projects-directory-base.projects-table.header.key',
		defaultMessage: 'Key',
		description: 'Projects table column heading for project key values',
	},
	type: {
		id: 'inactive-projects-directory-base.projects-table.header.type',
		defaultMessage: 'Type',
		description: 'Projects table column heading for project type values',
	},
	lead: {
		id: 'inactive-projects-directory-base.projects-table.header.lead',
		defaultMessage: 'Lead',
		description: 'Projects table column heading for project lead values',
	},
	category: {
		id: 'inactive-projects-directory-base.projects-table.header.category',
		defaultMessage: 'Category',
		description: 'Projects table column heading for project category values',
	},
	deletedOn: {
		id: 'inactive-projects-directory-base.projects-table.header.deleted-on',
		defaultMessage: 'Moved to trash on',
		description: 'Projects table column heading for moved to trash on date',
	},
	archivedOn: {
		id: 'inactive-projects-directory-base.projects-table.header.archived-on',
		defaultMessage: 'Archived on',
		description: 'Projects table column heading for archived on date',
	},
	deletingIn: {
		id: 'inactive-projects-directory-base.projects-table.header.deleting-in',
		defaultMessage: 'Permanently deleting',
		description: 'Projects table column heading for deleting in days',
	},
});
